import type { FC } from 'react'
import { useState, useMemo, useEffect } from 'react'
import { CartList } from 'modules/cart/components'
import { AddressView } from 'modules/address/components'
import { parserAddress } from 'fazendinha/address'
import { CardInfo } from 'components/cards'
import { Button, Loading } from 'components/ui'
import { OrderService } from 'modules/orders/services'
import { CustomerService } from 'modules/customers/services'
import { useCart } from 'hooks/use-cart'
import { CartProduct } from 'framework/cart'
import parseSeller from 'fazendinha/seller'
import router from 'next/router'
import { ROUTE_CHECKOUT } from 'routes/checkout'
import { useNotification } from 'hooks/use-notification'

import type { CheckoutOrderProps } from './types'
import s from './order-success.module.css'
import Link from 'next/link'

interface Item {
  id: string
  isAtacado: boolean
  price: number
  quantity?: number
  period?: string
  itemTotal?: number
  type: 'convencional' | 'experiencia'
  delivery_method?: string,
  [key: string]: any,
}

interface JadlogTrackingData {
  sellerId: number;
  url: string;
}

const OrderSuccess: FC<CheckoutOrderProps> = ({
  address,
  id,
  items,
  subtotal = 0,
  discount = 0,
  total,
  shipping,
  pre = 'Detalhes do pedido ',
  complement = '',
  note,
  status,
  children,
  enablePayment = false,
  jadlogSubOrders = [],
}) => {
  const { notify } = useNotification()
  const { addItem, inCart } = useCart()

  const [loading, setLoading] = useState<boolean>(false)

  console.log(jadlogSubOrders)
  const [jadlogTrackingData, setJadlogTrackingData] = useState<JadlogTrackingData[]>([]);

  useEffect(() => {
    const trackingData: (JadlogTrackingData | undefined)[] = jadlogSubOrders.map((subOrder: any) => {
      if(subOrder.jadlog_id_solicitacao) {
        return {
          sellerId: subOrder.produtor_id as number,
          url: subOrder.jadlog_link_rastreio as string,
        } as JadlogTrackingData
      }
    });

    setJadlogTrackingData(trackingData as JadlogTrackingData[]);
  }, [])

  async function addToCart(orderId: string) {
    const customerService = new CustomerService()
    const orderService = new OrderService(customerService)

    try {
      let orderData: any = null
      await orderService.getOrderById(
        orderId,
        // eslint-disable-next-line no-return-assign
        (x: any) => (orderData = x),
        () => {},
      )

      const products: any[] = orderData.items

      setTimeout(() => {
        products.forEach((item) => {
          const { product } = item

          if (!inCart(product.id)) {
            const image = product.images[0]?.nome
            const itemToAdd: Item = {
              id: product.id,
              isAtacado: false,
              price: product.preco,
              quantity: item.quantidade,
              type: product.tipo_produto ? product.tipo_produto : 'convencional',
              delivery_method: '',
              name: product.nome,
              slug: product.slug,
              imageUrl: image,
              itemTotal: product.preco * item.quantidade,
              lastChange: new Date(),
              seller: parseSeller(product.seller),
              assinatura: product.assinatura !== 0,
              assinatura_desconto_produtor: product.assinatura_desconto_produtor || 0,
              assinatura_frete_gratis: product.assinatura_frete_gratis || 0,
              assinatura_desconto_frete: product.assinatura_desconto_frete || 0,
            };
            addItem(itemToAdd, item.quantidade);
          }
      }, 2000) })
        notify({
          title: 'Seu carrinho está pronto',
          description: `${products.length === 1 ? 'foi adicionado' : 'foram adicionados'} ao seu carrinho`,
          type: 'success',
        })
        setLoading(false)
    } catch (e) {
      // console.log('e', e)
    }
  }

  async function buyAgain(orderId: string) {
    await addToCart(orderId)
    router.push(ROUTE_CHECKOUT)
  }

  const orderStatus = useMemo(() => {
    switch (status as unknown) {
      default:
      case 'processing':
        return 'Processando o pagamento'

      case 'pending':
        return 'Pendente'

      case 'paid':
        return 'Pago'

      case 'refunded':
        return 'Estornado'

      case 'waiting_payment':
        return 'Aguardando pagamento'

      case 'peding_refund':
        return 'Pagamento estornado'

      case 'refused':
        return 'Pagamento não autorizado'

      case 'chargeback':
        return 'Cobrado novamente'

      case 'analyzing':
        return 'Analisando'

      case 'pending_review':
        return 'Revisão pendente'

      case 'abandoned-cart':
        return 'Carrinho abandonado'

      case 'canceled':
        return 'Cancelado'
    }
  }, [status])

  return (
    <div className={s.root}>
      {loading && <Loading />}
      <h1 className={s.title}>
        {pre}#{id}
        {complement}
      </h1>
      <div>
        <span className={s.status}>{orderStatus}</span>
      </div>
      {children}
      {enablePayment && (
        <>
          <br />
          <div>
            <Button variant="secondary" onClick={() => addToCart(id)}>
              Comprar novamente
            </Button>
            &nbsp;|&nbsp;
            <Button variant="ghost" onClick={() => buyAgain(id)}>
              Pagar
            </Button>
          </div>
        </>
      )}
      <div className={s.cards}>
        <CardInfo title="Subtotal" value={(discount) ? (subtotal - discount).toString() : subtotal.toString() as unknown as string} />
        <CardInfo title="Frete" value={shipping as unknown as string} />
        <CardInfo title="Desconto" value={discount as unknown as string} />
        <CardInfo title="Valor total" value={total.toString() as unknown as string} />
      </div>
      <div className={s.subtitle}>Produtos</div>
      <CartList items={items} itemProps={{ canEdit: false, onChangeItemQuantity: () => {}, onDeleteItem: () => {} }} jadlogTrackingData={jadlogTrackingData} showTracking={true} />
      <div className={s.subtitle}>Endereço de entrega/cobrança</div>
      {address && <AddressView address={parserAddress(address as any, 'ENTREGA')} />}
      <div className={s.subtitle}>Observação</div>
      <p>{note && note.length > 0 ? note : 'Nenhuma observação'}</p>
    </div>
  )
}

export default OrderSuccess
